var styles = {"tw-react--aos--back-link":"BackLink-module_tw-react--aos--back-link__MksWf"};

export { styles as default };
